import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { convertData } from '../../../../../helpers/value'
import { selectUserType } from '../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../utils/authorization'
import BalanceBreakdownTrend from '../../common/balanceBreakdown/trend'
import {
  getNoDataComponent,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../helper'
import { changeChecked, selectChecked } from '../../store/slice'
import {
  TREND_ASSETS_CHECKBOXES,
  TREND_EQUITY_CHECKBOXES,
  TREND_LIABILITIES_CHECKBOXES,
} from './constant'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

export const Trend = ({ id, isDynamicReport, check, isDownloadComponent }) => {
  const dispatch = useDispatch()

  const { getExchangeRate, multiplier } = useFormatCurrency(
    SCREEN.FINANCIAL_ANALYSIS,
  )
  const userType = useSelector(selectUserType)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const checked = checkedStore || check

  const setChecked = (checked) => dispatch(changeChecked({ id, checked }))

  const assetsCheckboxs = TREND_ASSETS_CHECKBOXES.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))
  const liabilitiesCheckboxs = TREND_LIABILITIES_CHECKBOXES.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))
  const equityCheckboxs = TREND_EQUITY_CHECKBOXES.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))

  const dataConvert = convertData(
    dataByTrend,
    getExchangeRate,
    indicatorById,
    multiplier,
    ['year'],
    ['RT0172', 'FA018', 'RT0173'],
  )

  const isNoData = !dataConvert?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  const chart = []
  if (!isDynamicReport) {
    chart.push(...[1, 2, 3])
  } else {
    if (assetsCheckboxs.some(({ value }) => checked.includes(value))) {
      chart.push(1)
    }
    if (liabilitiesCheckboxs.some(({ value }) => checked.includes(value))) {
      chart.push(2)
    }
    if (equityCheckboxs.some(({ value }) => checked.includes(value))) {
      chart.push(3)
    }
  }

  return (
    <BalanceBreakdownTrend
      data={dataConvert}
      isCheckbox={userType?.userTypeId === USER_TYPE.PREMIUM}
      assetsCheckboxs={assetsCheckboxs}
      liabilitiesCheckboxs={liabilitiesCheckboxs}
      equityCheckboxs={equityCheckboxs}
      checked={checked}
      setChecked={setChecked}
      isDynamicReport={isDynamicReport || isDownloadComponent}
      chart={chart}
    />
  )
}
